import type {Moment} from 'moment-timezone'
import moment from 'moment-timezone'
import type {SubjectT} from '@freckle/educator-entities/ts/common/helpers/subjects'
import {fancyClient, extractData} from '@freckle/educator-entities/ts/openapi-clients'

export type LicenseT = {
  id: number
  schoolId: number
  count: number
  subject: SubjectT
  expiresAt: Moment
  startsAt: Moment
}

export async function fetchSchoolLicenses(
  schoolIds: Array<number>,
  active: boolean,
): Promise<Array<LicenseT>> {
  return fancyClient
    .GET('/2/licenses', {
      params: {
        query: {
          schoolIds,
          active,
        },
      },
    })
    .then(extractData)
    .then(data =>
      data.map(license => ({
        id: license.id,
        schoolId: license.schoolId,
        count: license.count,
        subject: license.subject,
        expiresAt: moment(license.expiresAt),
        startsAt: moment(license.startsAt),
      })),
    )
}
